import { render } from "./App.vue?vue&type=template&id=b45c5b18&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=b45c5b18&lang=css"

import exportComponent from "/home/mat/Descargas/qr-code-styling-examples-master/examples/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__